import Vue from 'vue'
import { VueMdi, library } from 'vue-mdi'
import * as icons from '@mdi/js'
import 'vue-mdi/dist/mdi.css';

library.add(icons);
Vue.component('vue-mdi', VueMdi);
